import { css } from '@microsoft/fast-element';

export const TabButtonsStyles = css`
  .tab-buttons {
    display: flex;
    flex-direction: row;
  }
`;
